// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Link as MaterialLink } from '@mui/material';
import { createLink } from '@tanstack/react-router';

/**
 * A styed link component for navigating within the application.
 */
export const Link = createLink(MaterialLink);
export const ExternalLink = MaterialLink;
export const InternalLink = createLink(MaterialLink);
